var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unlocked-list"},_vm._l((_vm.items),function(item){return _c('unlocked-list-item',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }